type AuthUserName = {
  given_name?: string
  name?: string
} | null

export function getDisplayFirstName({
  authUser,
  backendFirstName,
}: {
  authUser: AuthUserName | undefined
  backendFirstName: string | null | undefined
}) {
  const trimmedBackendFirstName = backendFirstName?.trim()
  if (trimmedBackendFirstName) {
    return trimmedBackendFirstName
  }

  const givenName = authUser?.given_name?.trim()
  if (givenName) {
    return givenName
  }

  const displayName = authUser?.name?.trim()
  if (!displayName) {
    return ''
  }

  return displayName.split(/\s+/)[0] ?? ''
}
